import Footer from "../components/footer";
import Header from "../components/header";
import { Link } from "react-router-dom";
import { Component } from "react";

class About extends Component {
    constructor()
    {
        super();
        this.state = {
            aboutcontent: [{title: <div className="row placeholder-fat"></div>, content: false}]
        }
        document.title = "About Voicecoach.net";
    }
    componentDidMount(){
        window.scroll(-1,0);
        fetch('https://api.voicecoach.net/view-about-you')
        .then(res => res.json())
        .then(jr => this.setState({
            aboutcontent: jr
        }));
    }

    render() {
        let ac = this.state.aboutcontent;
        ac = ac.map((c,i) => 
        <div className="row" key={i}>
            <div className="col-8 mx-auto">
                <div className="heading"><h2 className="fade-up">{c.title}</h2></div>
                {c.content ? (<div className="content mb-5 fade-up" dangerouslySetInnerHTML={{__html: c.content}} />) : 
                (<div className="row placeholder-content my-3"></div>)
                }
            </div>
        </div>
        )
        return <>
        <Header />
        <section className="mt-5 container">
        {ac}
        <div className="text-center">
        <Link to="/booking" className="btn big-button btn-primary mb-5">Start Learning</Link>
        </div>
        </section>
        <Footer />
        </>
    }
}

export default About;